/**
 * Physical address.
 */
export interface PhysicalAddress {
  readonly addressLine1: string
  readonly addressLine2: string
  readonly city: string
  readonly region: string
  readonly postalCode: string
  readonly country: string
}

export const PhysicalAddress = {
  /**
   * Empty physical address.
   */
  empty: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    region: '',
    postalCode: '',
    country: '',
  } satisfies PhysicalAddress,
}
